const w = window;
/**
 * @deprecated use `getFeatureFlags` from @sinch/feature-flags instead
 *
 * Type guard for boolean values.
 * @param x value to be evaluated.
 * @returns true if type of `x` is boolean.
 */
export const isBoolean = (x) => Boolean(typeof x === "boolean" || console.error(x, "is not a boolean"));
/**
 * @deprecated use `getFeatureFlags` from @sinch/feature-flags instead
 *
 * Type guard for strings containing urls. Validates that the passed
 * value is an url. If it is it asserts the type "string".
 * @param x potentially a string containing an url.
 * @returns true if `x` is a string containing an url, otherwise false.
 */
export const isValidUrl = (x) => {
    if (typeof x === "string" &&
        /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/i.test(x)) {
        return true;
    }
    console.error(x, "is not a valid URL");
    return false;
};
/**
 * @deprecated use `getFeatureFlags` from @sinch/feature-flags instead
 *
 * Type guard for strings containing domain names. Validates that the passed
 * value is a domain name. If it is it asserts the type "string".
 * @param x potentially a string containing a domain name.
 * @returns true if `x` is a string containing a domain name, otherwise false.
 */
export const isValidDomain = (x) => {
    if (typeof x === "string" &&
        /^(([a-z0-9]{1,2}|[a-z0-9][a-z0-9-_]{1,61}[a-z0-9])\.)+[a-z]{2,}$/i.test(x)) {
        return true;
    }
    console.error(x, "is not a valid domain name");
    return false;
};
/**
 * @deprecated use `getFeatureFlags` from @sinch/feature-flags instead
 *
 * Type guard for JSON values. Parses the JSON to see if it throws or not. It
 * does not do any assertion on what kind of data is in the JSON it just parsed.
 * If you are using Zod in your code base, that is probably a better validator
 * of your data.
 * @param x unknown value that may be a string containing JSON.
 * @returns true if able to parse JSON from x, otherwise false.
 */
export const isValidJSON = (x) => {
    try {
        JSON.parse(x);
    }
    catch (error) {
        console.error(x, "is not valid JSON", error);
        return false;
    }
    return true;
};
/** @deprecated use `getFeatureFlags` from @sinch/feature-flags instead */
export const useFeatureFlag = (flag, validator, fallback) => {
    const val = w?.ff?.[flag];
    if (validator(val)) {
        return val;
    }
    return fallback;
};
